import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'access-evo',
  name: 'Access Evo',
  category: 'access-integrations',
  description: 'Access Evo platform integration for members, tags, and groups',
  icon: 'Users',
  color: 'blue',
  version: '1.0.0',
  comingSoon: false,
  defaults: {
    name: 'Access Evo',
    color: '#3b82f6', // blue
  },
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  toolCapable: {
    enabled: true,
    name: 'access_evo_platform',
    description: 'Interact with Access Evo platform to manage members, tags, and groups within an organization',
    allowManualDescription: true,
    parameters: {
      action: {
        toolParamName: 'action',
        description: 'The operation to perform',
        required: true,
        type: 'string',
      },
      memberId: {
        toolParamName: 'memberId',
        description: 'The member ID (for getMember and updateMember actions)',
        required: false,
        type: 'string',
      },
      memberData: {
        toolParamName: 'memberData',
        description: 'JSON data for updating member',
        required: false,
        type: 'object',
      },
      tagId: {
        toolParamName: 'tagId',
        description: 'The tag ID (for updateTag action)',
        required: false,
        type: 'string',
      },
      userPropertyId: {
        toolParamName: 'userPropertyId',
        description: 'The user property ID containing the tag',
        required: false,
        type: 'string',
      },
      tagData: {
        toolParamName: 'tagData',
        description: 'JSON data for updating tag',
        required: false,
        type: 'object',
      },
      groupId: {
        toolParamName: 'groupId',
        description: 'The group ID (for updateGroup action)',
        required: false,
        type: 'string',
      },
      groupData: {
        toolParamName: 'groupData',
        description: 'JSON data for updating group',
        required: false,
        type: 'object',
      },
    },
  },
};

export default definition;
